import { svrBillingAmountToDecimalString } from "./svrBillingMoney";

function clean(value: string | null | undefined): string {
  return String(value ?? "").trim();
}

function iso(value: Date | string | null | undefined): string {
  if (value == null || value === "") return "";
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? "" : value.toISOString();
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? clean(value) : parsed.toISOString();
}

function fnv1a64Hex(text: string): string {
  let h = 0xcbf29ce484222325n;
  const prime = 0x100000001b3n;
  for (let i = 0; i < text.length; i++) {
    h ^= BigInt(text.charCodeAt(i));
    h = (h * prime) & 0xffffffffffffffffn;
  }
  return h.toString(16).padStart(16, "0");
}

export type SvrInvoiceFingerprintInput = {
  billingId: number;
  rate?: unknown;
  invoiceDescription?: string | null;
  invoiceKey?: string | null;
  invoiceUrl?: string | null;
  invoiceToken?: string | null;
  paymentLink?: string | null;
  raisedAt?: Date | string | null;
};

/** Canonical content/version identity of the invoice being sent to the customer. */
export function buildSvrInvoiceContentFingerprint(input: SvrInvoiceFingerprintInput): string {
  const amount = input.rate == null || input.rate === ""
    ? ""
    : svrBillingAmountToDecimalString(input.rate);
  const canonical = [
    `id:${Number(input.billingId) || 0}`,
    `amt:${amount}`,
    `desc:${clean(input.invoiceDescription)}`,
    `pdf:${clean(input.invoiceKey) || clean(input.invoiceUrl)}`,
    `token:${clean(input.invoiceToken)}`,
    `pay:${clean(input.paymentLink)}`,
    `raised:${iso(input.raisedAt)}`,
  ].join("\n");
  return `v1:${fnv1a64Hex(canonical)}`;
}

export function svrInvoiceFingerprintsEqual(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  const left = clean(a);
  const right = clean(b);
  if (!left || !right) return false;
  return left === right;
}
